<template>
	<div>
		<div>
			<img src="../../../public/pic/product/accompany/E.png" style="width: 100%;height: 600px;"/>
		</div>
		<br /><br />
		<div style="width: 1000px;margin: 0 auto;">
			
			<p style="font-size: 40px;">{{ $t('lang.Companion')}}{{ $t('lang.Robot')}}</p>
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/11.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/12.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/13.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/14.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/15.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/16.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/17.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/18.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/19.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/20.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/21.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/22.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/23.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/24.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/25.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/26.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/27.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/28.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/29.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/30.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/31.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/32.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/33.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/34.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/35.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/36.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/37.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/38.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/39.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/40.png" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/accompany/PH1.png" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/accompany/PH11.png" />
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '陪护机器人_深圳全智能机器人科技有限公司。AI Robot Sex Doll _Shenzhen all intelligent robot technology Co., Ltd',
			keywords : '陪护机器人,美女机器人,硅胶实体娃娃,智能机器人厂家,实体娃娃厂家,仿真陪伴机器人, 美女仿真机器人。 AI robot sex doll,love doll,TPE sex doll,Adult doll,Doll Sex,Sex doll for men,Sexy Dolls,silicone doll,Intelligent robot manufacturer,doll manufacturer,China factory sex doll,Sexy girl robot',
			description : '深圳全智能机器人科技有限公司基于Android系统、计算机技术、互联网、新型高分子材料和美学艺术而自主研发、制造和销售的陪护机器人。在智能化程度方面，是国内企业继科大讯飞、图灵智能语音平台之外，又一个拥有自主知识产权（2018SR654839)的高智能仿真机器人---菲菲。支持订制化服务，其身高、胸围，臀围，肤色、发型等可以进行适当选择。其肌肤采用新型自主改性高分子材料M-TPE，不易撕裂；更加安全、可靠、稳定，手感更加舒适、细腻。Based on Android system, computer technology, Internet, new polymer materials and aesthetic arts, Shenzhen all intelligent robot technology Co., Ltd. independently develops, manufactures and sells accompanying robots.In terms of intelligence, Feifei is another high intelligent simulation robot with independent intellectual property rights (2018sr654839) in addition to iFLYTEK and Turing intelligent voice platform.Support customized service, its height, chest circumference, hip circumference, skin color, hair style, etc. can be appropriately selected.Its skin adopts a new self modified polymer material m-tpe, which is not easy to tear; it is more safe, reliable and stable, and its hand feel is more comfortable and delicate.',
			};
	},
}
</script>

<style scoped>
	img{
		position:relative;
		clear:both;
		width:100%;
		height:100%;
	}
	#background{
		width: 100%;
		height: 1800px;
		background-image: url('../../../public/pic/product/accompany/b1.png');
	}

</style>
